<template>
  <div>
    <div
      v-if="loader.page || errors.alert"
      class="d-flex-justify-content-center"
    >
      <LoaderLogo :loading="loader.page" />
      <Alert
        v-if="errors.alert"
        :title="LABEL.ERRORI.PREFIX"
        :description="LABEL.ERRORI[errors.alert]"
        :btn="{
          label: LABEL.ERRORI.BACK_TO_REQUESTS,
          icon: 'arrow-left',
          action: () => this.$router.push({ name: nameRoutes.RICHIESTE }),
        }"
      />
    </div>
    <div class="position-relative" v-if="!errors.alert">
      <section
        v-if="!loader.page"
        :class="`opacity-${lateralCard.open ? '0' : '1'} SisrCenterCard ${
          lateralCard.open ? 'open' : ''
        }`"
      >
        <header>
          <h5
            class="text-gray-900 font-weight-bold"
            style="margin-bottom: 25px"
          >
            <font-awesome-icon icon="utensils" class="mr-2" />
            {{
              LABEL.PORTATA.PAGE_TITLE(portata.nomePasto, portata.dataRichiesta)
            }}
          </h5>
        </header>
        <div class="tab-content" id="nav-tabContentent">
          <article
            :class="`SisrCard br-10 container-card ${
              lateralCard.open ? 'd-none' : ''
            } shadow-sm`"
          >
            <header class="text-gray-800">
              <h6>
                <font-awesome-icon icon="utensil-spoon" class="mr-2" />
                <span class="font-weight-bold">{{ portata.nomePortata }}</span
                >&nbsp;-&nbsp;{{
                  LABEL.PORTATA.CARD_SUBTITLE(
                    portata.massimoPiattiSelezionabili
                  )
                }}
              </h6>
            </header>
            <List
              :items="portata.piatti"
              :itemCheckbox="checkbox"
              @checkboxChange="(piatto) => checkboxChange(piatto)"
              @detailClicked="(piatto) => setLateralCardOpen(piatto)"
            />
            <SaveButton
              :loading="loader.update"
              :text="LABEL.PORTATA.SAVE"
              :error="errors.update"
              primaryIcon="check"
              @saving="updatePortata"
              @updateErrorValue="updateUpdateError"
              class="font-weight-bold m-auto"
              style="margin-bottom: 12.5px !important"
            />
            <button
              class="btn btn-danger d-block m-auto"
              style="font-size: 14px"
              @click="backToVassoio"
            >
              <span class="d-flex align-items-center">
                <font-awesome-icon icon="times" class="mr-2" />
                {{ LABEL.PORTATA.CANCEL }}
              </span>
            </button>
          </article>
        </div>
      </section>
      <div
        id="SisrLateralDetails"
        :class="`SisrLateralCard leftLateralCard opacity-${
          lateralCard.open ? '1 open' : '0'
        }`"
      >
        <article
          v-if="!!Object.entries(lateralCard.details).length"
          class="SisrCard br-10 container-card"
        >
          <header class="text-gray-800">
            <h6 class="font-weight-bold d-flex">
              <font-awesome-icon icon="exclamation-triangle" class="mr-2" />{{
                lateralCard.details.detailsListTitle
              }}
            </h6>
          </header>

          <ul
            id="phoneNavigation"
            class="nav nav-tabs d-block"
            style="margin-bottom: 1rem; border: none"
            role="tablist"
          >
            <li
              class="
                nav-item
                d-flex
                justify-content-between
                align-items-center
                SisrCardOption
              "
              v-for="(detail, index) in lateralCard.details.detailsList"
              :key="`detail${index}`"
            >
              <span class="d-block SisrLabel w-100">
                {{ detail }}
              </span>
            </li>
          </ul>
          <button
            class="btn btn-secondary d-block m-auto"
            @click="setLateralCardOpen()"
          >
            <span>
              <font-awesome-icon icon="arrow-left" class="mr-2" />
              {{ LABEL.PORTATA.BACK }}
            </span>
          </button>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { portataMixin } from "../../libs/mixins/application";
export default {
  mixins: [portataMixin],
};
</script>
